import { IImageDimension, IImageSettings, IViewPort } from '@msdyn365-commerce/core';

export function findImagesSettingsInProps(props: any, onFound: (result: IImageSettings) => void) {
    if (!props) {
        return;
    }
    Object.keys(props).forEach(key => {
        if (key === '_owner' || key === 'type' || key === 'tag' || key === 'requestContext') {
            return;
        }

        if (key === 'imageSettings') {
            onFound(props[key]);
        } else if (key === 'props' || key === 'children' || key === 'items' || key === 'Picture' || key.match(/^\d+$/m) && typeof props[key] === 'object') {
            findImagesSettingsInProps(props[key], onFound);
        }
    });
}

export function fixImageSettings(imageSettings: IImageSettings, removeSpecificImageSize: boolean = false, mode: number = 0, height?: number, width?: number) {
    imageSettings.mode = mode;

    if (!imageSettings.viewports) {
        imageSettings.viewports = {} as IViewPort;
    }

    imageSettings.viewports.lg = imageSettings.viewports.lg || {} as IImageDimension;
    imageSettings.viewports.md = imageSettings.viewports.md || {} as IImageDimension;
    imageSettings.viewports.sm = imageSettings.viewports.sm || {} as IImageDimension;
    imageSettings.viewports.xl = imageSettings.viewports.xl || {} as IImageDimension;
    imageSettings.viewports.xs = imageSettings.viewports.xs || {} as IImageDimension;

    Object.keys(imageSettings.viewports || {}).forEach(key => {
        const params = new URLSearchParams(imageSettings.viewports[key].q);

        params.set('f', 'webp');
        params.set('m', mode.toString());

        if (removeSpecificImageSize) {
            params.delete('w');
            params.delete('h');
        } else {
            if (width) {
                params.set('w', width.toString());
            }
            if (height) {
                params.set('h', height.toString());
            }
        }

        imageSettings.viewports[key].q = params.toString();
    });
}

export function findAndFixImageSettingsInProps(props: any, removeSpecificImageSize: boolean = false, mode: number = 0) {
    findImagesSettingsInProps(props, (imageSettings: IImageSettings) => {
        fixImageSettings(imageSettings, removeSpecificImageSize, mode);
    });
}